module.exports = __webpack_public_path__ + "img/C03TechCallOfTheBoar_ua.39e15850.webp";